export const config = {
  apiUrl: 'https://countries-274616.ew.r.appspot.com',
};

export default {
  config,
};
